import $ from "jquery"
import "popper.js"
import "bootstrap"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { store } from "./store/store"
import "intl-tel-input/build/css/intlTelInput.css"
import "./assets/styles/main.css"
import smoothscroll from "smoothscroll-polyfill"

//Polyfill array.prototype.flatMap and array.prototype.flat for Safari 11.0 and below, can remove once we update to vue-cli > 4.x
import "core-js/fn/array/flat-map"
import "core-js/fn/array/flatten"

if (!Array.prototype.flat) {
	Array.prototype.flat = Array.prototype.flatten
}

window.$ = window.jQuery = $

import axios from "axios"
import VueAxios from "vue-axios"
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import api from "./api"
import "@/directives"
import BugsnagPluginVue from "@bugsnag/plugin-vue"
import facebook from "@/services/facebook"
import google from "@/services/google"

const bugsnagPluginVue = new BugsnagPluginVue(Vue)

if (window["bugsnagClient"]) {
	bugsnagPluginVue.load(window["bugsnagClient"])
}

Vue.use(VueAxios, axios)
Vue.use(Loading, {
	color: "#000000",
	loader: "spinner",
	width: 64,
	height: 64,
	backgroundColor: "#ffffff",
	opacity: 0.5
})
Vue.config.productionTip = false
api.setGlobalHeaders()
Vue.prototype.bugsnag = window["bugsnagClient"]
Vue.prototype.$mobileWidth = 500
Vue.prototype.$logoSrc = `${process.env.VUE_APP_BASE_WEBAPP_IMAGE_URL}get-reef-logo.svg`
Vue.prototype.$logoLightSrc = `${process.env.VUE_APP_BASE_WEBAPP_IMAGE_URL}get-reef-logo-white.svg`
Vue.prototype.$brandsCDNURL = `${process.env.VUE_APP_BASE_IMAGE_URL}brands/`
Vue.prototype.$staticAssetUrl = `https://d3nqailfwc1nr3.cloudfront.net/`
Vue.prototype.$cdnUrl = `${process.env.VUE_APP_BUSINESS_CDN_URL}/`

//Enable smoothscroll polyfill to support smoothscroll behavior options for Safari
smoothscroll.polyfill()

facebook.initialize()
google.initialize()

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount("#app")
